<template>
  <v-col v-if="canView" cols="auto">
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          small
          class="ai-diff-button ml-2"
          :loading="loading"
          :disabled="disabled"
          v-bind="attrs"
          v-on="on"
          @click="handleClick"
        >
          <v-icon small color="white">mdi-robot</v-icon>
        </v-btn>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </v-col>
</template>

<script>
export default {
  name: 'AIButton',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    canView: {
      type: Boolean,
      default: false,
    },
    isV2: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tooltipText() {
      return this.isV2 ? 'Ask MAV (Shift+Click to open)' : 'Ask MAV';
    },
  },
  methods: {
    handleClick(event) {
      if (this.isV2 && event.shiftKey) {
        this.$emit('generate-direct');
      } else {
        this.$emit('generate');
      }
    },
  },
};
</script>

<style scoped>
.ai-diff-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3) !important;
  transition: all 0.3s ease !important;

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important;
    box-shadow: 0 6px 12px rgba(102, 126, 234, 0.5) !important;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
  }
}
</style>
